import React from 'react'
import { EvidenceGroup } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { DocumentRequest } from '@trustero/trustero-api-web/lib/request/request_pb'
import { useMemo } from 'react'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { Grid } from 'src/components/Reusable/Grid'
import { RequestsItem } from 'src/pages/Requests/components/RequestsItem'
import { RequestsIndexGridHeader } from 'src/pages/Requests/RequestsIndexPage/RequestsIndexGridHeader'
import { REQUESTS_GRID_TEMPLATE_COLUMNS } from 'src/pages/Requests/RequestsIndexPage/RequestsIndexPage.constants'
import { DocumentRequestsTabNoResults } from 'src/pages/Evidence/evidence.components'
import { LinkEvidenceToRequestsModal } from 'src/pages/Evidence/modals/LinkEvidenceToRequestsModal'
import { BasicDropdownProvider } from 'src/components/Reusable/BasicDropdown/context/BasicDropdownContext'
import { EvidenceRequestsItemMenu } from './EvidenceDocumentRequestsBody.components'

export const EvidenceDocumentRequestsBody = ({
  evidence,
  requests,
  isLoading,
}: {
  evidence: EvidenceGroup
  requests: DocumentRequest[]
  isLoading: boolean
}): JSX.Element => {
  const currentRequestIds = useMemo(
    () => requests.map((r) => r.getId()),
    [requests],
  )

  return isLoading ? (
    <TableListLoader />
  ) : (
    <>
      {requests.length ? (
        <Grid
          gridTemplateColumns={REQUESTS_GRID_TEMPLATE_COLUMNS}
          gridRowGap="8px"
        >
          <RequestsIndexGridHeader requests={requests} />
          <BasicDropdownProvider>
            {requests.map((request) => (
              <RequestsItem
                key={request.getId()}
                request={request}
                fromEvidenceShowPage
                customMenu={
                  <EvidenceRequestsItemMenu
                    request={request}
                    evidenceGroup={evidence}
                  />
                }
              />
            ))}
          </BasicDropdownProvider>
        </Grid>
      ) : (
        <DocumentRequestsTabNoResults />
      )}
      <LinkEvidenceToRequestsModal
        existingRequestIds={currentRequestIds}
        evidenceId={evidence.getEvidenceId()}
      />
    </>
  )
}
